export default __webpack_public_path__ + "static/media/Stage4_title.4876c991.png";